<template>
  <div>
    <el-dialog v-model="dialogTableVisible" trigger="hover" :title="title" width="500" @close="close" >
      <el-form  :model="formInline" class="demo-form-inline">
        <el-form-item label="入库类型">
          <el-select
              v-model="formInline.inType"
              filterable
              reserve-keyword
              placeholder="请选择入库方式"
              remote-show-suffix
              :loading="loading"
              style="width: 240px"
          >
            <el-option
                v-for="item in typeList"
                :key="item"
                :label="item"
                :value="item"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="退货仓库">
          <el-select
              v-model="formInline.warehouseId"
              filterable
              reserve-keyword
              placeholder="请选择仓库"
              remote-show-suffix
              :loading="loading"
              style="width: 240px"
          >
            <el-option
                v-for="item in stockList"
                :key="item.warehousefCode"
                :label="item.warehouseName"
                :value="item.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item  label="入库SKU">
          <el-input style="width: 240px" v-model="formInline.sku" placeholder="请输入sku" ></el-input>
        </el-form-item>
        <el-form-item  label="入库数量">
          <el-input type="number" style="width: 240px" v-model="formInline.quantity" placeholder="请输入退货数量" ></el-input>
        </el-form-item>
        <el-form-item label="物流单号">
          <el-select
              v-model="formInline.trackNumber"
              multiple
              filterable
              allow-create
              reserve-keyword
              placeholder="请选择物流单号"
              remote-show-suffix
              :loading="loading"
              style="width: 240px"
          >
            <el-option
                v-for="item in trackNumberList"
                :key="item"
                :label="item"
                :value="item"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="备注">
          <el-input
              v-model="formInline.remark"
              type="textarea"
              placeholder="请输入备注信息"
              rows="3"
              style="width: 240px"
          ></el-input>
        </el-form-item>
        <el-form-item >
          <el-button style="margin: 0 auto" type="primary" @click="onSubmit">{{botton}}</el-button>
        </el-form-item>

      </el-form>
    </el-dialog>
  </div>
</template>
<script >
import {ElDialog, ElForm, ElFormItem, ElButton, ElMessage,ElSelect,ElOption,ElInput} from "element-plus";
import {getFullUrl,isValidEmail,getLocalStockList} from "@/../public/js/index"
import {uploadUrl} from "@/utils/requset";
import {addTempInStoreTrack,getTempInStoreTrack} from "@/utils/api"
export default {
  name: "addInStore",
  components:{
    ElDialog,ElForm,ElFormItem,ElButton,ElSelect,ElOption,ElInput
  },
  mixins:[getFullUrl,isValidEmail],
  data(){
    return{
      dialogTableVisible:false,
      title:"手工入库",
      botton:"保存",
      formInline:{
        trackNumber:[]
      },
      reMarks:false,
      stockList:[],
      typeList:["海外仓调拨入库","未知来源退货入库","Target退货","沃尔玛平台仓移除","亚马逊平台仓移除","Bestbuy退货","库存调整","售后仓换包装","售后仓完成维修"],
      trackNumberList:[],
      uploadUrl:'',
      dialogVisible:false
    }
  },
  beforeMount(){
    this.uploadUrl = uploadUrl
    this.getLocalStockList()

  },
  methods:{
    getLocalStockList(){
      getLocalStockList().then(res => {
        this.stockList = res.filter(item=>{
          return item.warehouseName.includes("美国售后仓")
        })
      })
    },
    getTempInStoreTrack(data){
      getTempInStoreTrack(data).then(res=>{
          this.trackNumberList = res.Data
      }).catch(err=>{
        console.log(err)
      })
    },
    open(data){
      console.log(data)
      this.dialogTableVisible=true
      let inType = "亚马逊平台仓移除"
      const checkRemarks = data.check_remarks || ""
      if(checkRemarks.includes("best")){
        inType = "Bestbuy退货"
      }else if(checkRemarks.includes("target")){
        inType = "Target退货"
      }else if(checkRemarks.includes("未知")){
        inType = "未知来源退货入库"
      }else if(checkRemarks.includes("沃尔玛")){
        inType = "沃尔玛平台仓移除"
      }
      this.formInline = {
        tempInStoreId:data.tempInStoreId,
        sku:data.sku,
        inType: inType,
        warehouseId:data.warehouseId,
        trackNumber:[data.trackNumber],
        quantity:data.quantity,
        quantitys:data.quantity,
        remark:"临时入库-手工入库-" + data.trackNumber
      }
      this.getTempInStoreTrack({tempInStoreId:data.tempInStoreId})
    },
    onSubmit(){
      console.log(this.formInline)
      if(!this.formInline.inType){
        ElMessage.warning('请选择手工入库方式')
        return
      }
      if(!this.formInline.warehouseId){
        ElMessage.warning('请选择仓库')
        return
      }
      if(this.formInline.quantity<=0 || this.formInline.quantitys<this.formInline.quantity){
        ElMessage.warning("请输入正确的数量")
        return
      }
      if (this.formInline.trackNumber.length==0){
        ElMessage.warning("请选择或输入物流单号")
        return
      }
      this.formInline.receiveWarehouse = this.stockList.filter(item=>{
        return item.id == this.formInline.warehouseId
      })

      this.formInline.Warehouse = this.formInline.receiveWarehouse[0].warehouseName
      addTempInStoreTrack(this.formInline).then(res=>{
          console.log(res)
          this.dialogTableVisible=false
          ElMessage.success('保存成功')
      }).catch(err=>{
        console.log(err)
      })
    },
    close(){
      this.dialogTableVisible = false
      this.$emit('closeEdit')
    },
  }
}
</script>
<style scoped>
::v-deep .el-form-item__label{
  width: 100px;
}
.span{
  color: #f56c6c;
  font-size: 12px;
}

</style>